import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import { SVGProps } from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const VideoIcon: React.FC<IconProps & SVGProps<SVGSVGElement>> = ({
  color = "#fd6a65",
  withBackground,
  ...rest
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g fill={color}>
            <path
              d="M9.757 22.126V9.875c0-.964 0-1.446.201-1.715a1.01 1.01 0 0 1 .736-.401c.335-.024.74.236 1.551.757l9.529 6.126c.703.452 1.055.678 1.176.965a1.01 1.01 0 0 1 0 .786c-.121.287-.473.514-1.176.966l-9.529 6.125c-.81.521-1.216.782-1.55.758a1.01 1.01 0 0 1-.737-.402c-.201-.269-.201-.75-.201-1.714Z"
              fillRule="nonzero"
              opacity=".12"
            />
            <path d="m12.625 7.86.03.02 9.528 6.125.028.018c.328.21.616.396.835.566.225.176.465.401.601.724.186.439.186.935 0 1.374-.136.323-.376.548-.601.724-.219.17-.507.356-.835.566l-.028.018-9.529 6.126-.029.019c-.38.244-.709.455-.984.599-.277.144-.617.285-1 .258a1.766 1.766 0 0 1-1.289-.704c-.23-.307-.295-.67-.324-.98C9 23.002 9 22.612 9 22.16V9.84c0-.452 0-.843.028-1.152.029-.31.094-.674.324-.981.307-.41.777-.667 1.288-.704.384-.027.724.114 1 .258.276.144.605.355.985.6Zm-1.891.655a.252.252 0 0 0-.16.088 1.03 1.03 0 0 0-.038.223c-.021.232-.022.552-.022 1.048v12.252c0 .496 0 .816.022 1.048.013.145.032.206.037.223.041.049.098.08.16.088.018-.004.08-.022.209-.09.206-.107.476-.28.894-.548l9.528-6.125c.364-.234.593-.382.75-.505a.893.893 0 0 0 .143-.128.253.253 0 0 0 0-.178.893.893 0 0 0-.142-.128c-.158-.123-.387-.27-.75-.505l-9.53-6.125a13.196 13.196 0 0 0-.893-.549 1.03 1.03 0 0 0-.208-.089Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
